import React, { useState } from "react"

import { ResetPasswordConfirmForm } from "./Form"
import { ResetPasswordConfirmSubmitted } from "./Submitted"

export const ResetPasswordConfirmScreenContent = () => {
  const [isSubmitted, setIsSubmitted] = useState(false)

  return <>
    {isSubmitted ? <ResetPasswordConfirmSubmitted/> : <ResetPasswordConfirmForm
      executeOnSuccess={() => setIsSubmitted(true)}/>}
  </>
}
